import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCpanelComponent } from './simple-icons-cpanel.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCpanelComponent ],
    exports:      [ SimpleIconsCpanelComponent ],
    bootstrap:    []
})
export class SimpleIconsCpanelModule {}
